export default __webpack_public_path__ + "static/media/chart.3d96b740.webp";